// extracted by mini-css-extract-plugin
module.exports = {"header":"connect-modal-header_header__2PbXN","paynet":"connect-modal-header_paynet__1qWGy","divider":"connect-modal-header_divider__1TFCp"};